"use client";

import { ArrowRight, Gem, Menu } from "lucide-react";
import { Link } from "@/i18n/navigation";
import { usePathname } from "next/navigation";
import { FC, useEffect, useState } from "react";

interface MobileNavProps {
  isAuthed: boolean;
  isSubscribed: boolean;
}

const MobileNav: FC<MobileNavProps> = ({ isAuthed, isSubscribed }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleOpen = () => setIsOpen((prev) => !prev);

  // close nav when pathname or isOpen changes
  const pathname = usePathname();
  useEffect(() => {
    if (isOpen) toggleOpen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const closeOnCurrent = (href: string) => {
    if (pathname === href) toggleOpen();
  };

  return (
    <div className="sm:hidden flex pl-4 justify-center items-center">
      <Menu
        onClick={toggleOpen}
        className="relative z-50 h-7 w-7 bg-blur-xl  text-card-foreground shadow-sm rounded-2xl background-blur-3xl text-zinc-700"
        data-umami-event="mobile-nav-button-clicked"
      />

      {isOpen ? (
        <div className="bg-card fixed animate-in slide-in-from-top-5 fade-in-20 inset-0 z-0 w-full rounded-lg">
          <ul className="bg-card absolute border-b shadow-xl grid w-full gap-3 px-5 pt-20 pb-8  dark:bg-card-to-t dark:from-border dark:to-background">
            {!isAuthed ? (
              <>
                <li>
                  <Link
                    className="flex items-center w-full font-semibold"
                    href="/"
                    onClick={() => closeOnCurrent("/")}
                    data-umami-event="mobile-get-started-button-clicked"
                  >
                    Home
                  </Link>
                </li>
                <li className="my-3 h-px w-full bg-gray-300" />
                <li>
                  <Link
                    className="flex items-center w-full font-semibold"
                    href="/templates"
                    // onClick={() => closeOnCurrent("/templates")}
                    // data-umami-event="mobile-get-started-button-clicked"
                  >
                    Templates
                  </Link>
                </li>

                <li className="my-3 h-px w-full bg-gray-300" />
                <li>
                  <Link
                    className="flex items-center w-full font-semibold"
                    href="/pricing"
                    // onClick={() => closeOnCurrent("/pricing")}
                    // data-umami-event="mobile-pricing-button-clicked"
                  >
                    Pricing
                  </Link>
                </li>
                <li className="my-3 h-px w-full bg-gray-300" />
                <li>
                  <Link
                    className="flex items-center w-full font-semibold"
                    href="/docs"
                    // onClick={() => closeOnCurrent("/docs")}
                    // data-umami-event="mobile-sign-in-button-clicked"
                  >
                    Docs
                  </Link>
                </li>
                <li className="my-3 h-px w-full bg-gray-300" />
                <li>
                  <Link
                    className="flex items-center w-full font-semibold"
                    href="https://discord.gg/nNCnHybP"
                    // onClick={() => closeOnCurrent("/docs")}
                    // data-umami-event="mobile-sign-in-button-clicked"
                  >
                    Discord
                  </Link>
                </li>

                <li className="my-3 h-px w-full bg-gray-300" />
              </>
            ) : (
              <>
                <li>
                  <Link
                    className="flex items-center w-full font-semibold"
                    href="/dashboard"
                    // onClick={() => closeOnCurrent("/dashboard")}
                    // data-umami-event="mobile-dashboard-button-clicked"
                  >
                    Dashboard
                  </Link>
                </li>
                <li className="my-3 h-px w-full bg-gray-300" />
                <li>
                  <Link
                    className="flex items-center w-full font-semibold"
                    href="/top-up"
                    // onClick={() => closeOnCurrent("/pricing")}
                    // data-umami-event="mobile-pricing-button-clicked"
                  >
                    Buy Credits
                  </Link>
                </li>
                <li className="my-3 h-px w-full bg-gray-300" />
                {!isSubscribed ? (
                  <li>
                    <Link
                      href="/pricing"
                      className="flex items-center w-full font-semibold"
                      // data-umami-event="mobile-upgrade-button-clicked"
                    >
                      Upgrade <Gem className="text-purple-600 h-4 w-4 ml-1.5" />
                    </Link>
                  </li>
                ) : (
                  <li>
                    <Link
                      className="flex items-center w-full font-semibold"
                      href="/account"
                      // onClick={() => closeOnCurrent("/account")}
                      // data-umami-event="mobile-manage-subscription-button-clicked"
                    >
                      Manage Subscription
                    </Link>
                  </li>
                )}
                <li className="my-3 h-px w-full bg-gray-300" />
                <li>
                  <Link
                    className="flex items-center w-full font-semibold"
                    href="/sign-out"
                    // data-umami-event="mobile-sign-out-button-clicked"
                  >
                    Sign Out
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      ) : null}
    </div>
  );
};

export default MobileNav;
